const SIDE_PANEL_OPENED = [{ width: '70%' }, { width: '30%' }]
const SIDE_PANEL_CLOSED = [{ width: '100%' }, { width: '0%' }]

// eslint-disable-next-line import/prefer-default-export
export { SIDE_PANEL_OPENED, SIDE_PANEL_CLOSED }
